// extracted by mini-css-extract-plugin
export var blue = "_11-f";
export var brand = "_11-b";
export var darkGrey = "_11-e";
export var disabled = "_11-4";
export var disabledSubtle = "_11-5";
export var error = "_11-6";
export var green = "_11-g";
export var grey = "_11-d";
export var icon = "_11-0";
export var inherit = "_11-a";
export var lightGrey = "_11-c";
export var orange = "_11-i";
export var pink = "_11-k";
export var primary = "_11-1";
export var purple = "_11-l";
export var red = "_11-j";
export var secondary = "_11-2";
export var success = "_11-9";
export var tertiary = "_11-3";
export var warning = "_11-7";
export var warningSecondary = "_11-8";
export var white = "_11-m";
export var yellow = "_11-h";